// Compact UI projection. Private collection names are used only for tooltips,
// never forwarded to the usage profiler.
export function legacyChartActionKey(stock) {
  stock = stock || {};
  return JSON.stringify([stock.ticker, String(stock.direccio == null ? '' : stock.direccio),
    String(stock.tipus_entrada == null ? '' : stock.tipus_entrada)]);
}

export function legacyChartActions(stock, user, loggedIn, features, workspaces = []) {
  stock = stock || {}; user = user || {};
  const folders = Array.isArray(stock.folder_name) ? stock.folder_name : [];
  const folder = folders.length === 1 && workspaces.find(item => item.name === folders[0]);
  const available = Boolean(stock.ticker && stock.nom !== '---' && loggedIn && !user.is_only_authenticated_user && features && features.has_active_role);
  const roles = user.roles || {};
  const open = Boolean(stock.open_positions_portfolio_name);
  const waiting = stock.waitings_portfolio_name != null;
  return {
    key: legacyChartActionKey(stock), ticker: stock.ticker || '',
    favorites: available, portfolio: available && !roles[21] && !roles[20],
    favorite: folders.length > 0, favoriteColor: folder ? folder.color : '',
    favoriteTitle: folders.length ? `Favoritos: ${folders.join(', ')}` : 'Añadir a favoritos',
    portfolioState: open ? 'open' : waiting ? 'waiting' : 'none',
    portfolioTitle: open ? `Posición abierta: ${stock.open_positions_portfolio_name}` : waiting ? `En espera: ${stock.waitings_portfolio_name}` : 'Añadir a cartera'
  };
}
